import type { RechercheDemandeQueryDTO, RechercheResultDTO } from '@/features/api/extranet/dto/Demande/Recherche'
import { buildRechercheStore } from '../storeRechercheBuilder'

export const useRechercheDemandeTTStore = buildRechercheStore<RechercheDemandeQueryDTO, RechercheResultDTO>({
  storeName: 'rechercheDemandeTTStore',
  apiPath: `/specifiquett/demandes`,
})
